import React from 'react';
import PropTypes from 'prop-types';
import { observer } from "mobx-react-lite";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import FindConsultationTabPanel from './FindConsultationTabPanel';
import FindScansTabPanel from './FindScansTabPanel';
import dogImage from '../assets/about-image-1.svg';

const PageNavigationTabsStyled = styled('div')(({ theme }) => ({
    padding: '0',
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
        padding: '1rem',
    }
}));

const ImageHolderStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: '100%',
    '& img': {
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'cover',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease-in-out',
    },
    [theme.breakpoints.up('md')]: {
       flexBasis: '50%',
    },
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        '&.Mui-selected': {
            color: '#000',
            fontWeight: 'bold'
        },
        '&.Mui-focusVisible': {
            backgroundColor: '#19BFB7',
            fontWeight: 'bold'
        },
        '&:hover': {
            color: '#000',
            fontWeight: 'bold',
            opacity: 1,
        },
    }),
);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};

const PageNavigationTabs = observer(props => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, val) => {
        setValue(val);
    };

    return (
        <PageNavigationTabsStyled>
            <Box sx={(theme) => ({
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '1.5rem',
                flexDirection: 'column',
                [theme.breakpoints.up('md')]: {
                    gap: '3rem',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }
            })}>
                <Box sx={(theme) => ({
                    width: '100%',
                    [theme.breakpoints.up('md')]: { 
                        flexBasis: '50%'
                    }
                })}>
                    <Tabs value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        sx={{ borderBottom: 1, borderColor: '#C7E0DF' }}
                    >
                        <StyledTab label="Find a consultation" {...a11yProps(0)} sx={{width: '17rem'}}/>
                        <StyledTab label="Find a scan" {...a11yProps(1)} />
                        
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <FindConsultationTabPanel ></FindConsultationTabPanel>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <FindScansTabPanel></FindScansTabPanel>
                    </TabPanel>
                </Box>
                <ImageHolderStyled>
                    <img src={dogImage} alt="Healthcare illustration" />
                </ImageHolderStyled>
            </Box>
        </PageNavigationTabsStyled>
    );
});

export default PageNavigationTabs;